import {PageHeader} from './PageHeader'
import {PageItem} from './PageItem'
import {PageContent} from './PageContent'

import type {PageItemProps} from './PageItem'
import type {PageHeaderProps} from './PageHeader'
import type {ReactNode} from 'react'

export interface PageTemplateProps extends PageItemProps {
  id?: string
  headerChildren?: ReactNode
  children?: ReactNode
  callout?: PageHeaderProps['callout']
  title?: PageHeaderProps['title']
  subTitle?: PageHeaderProps['subTitle']
}

export const PageTemplate = ({
  id,
  callout,
  title,
  subTitle,
  headerChildren,
  children,
  ...restProps
}: PageTemplateProps) => (
  <PageItem {...restProps}>
    <PageHeader
      id={id}
      callout={callout}
      title={title}
      subTitle={subTitle}
    >
      {headerChildren}
    </PageHeader>
    <PageContent>
      {children}
    </PageContent>
  </PageItem>
)
